import fetch from "@lib/fetch";
import { API } from "../../config";

export const getLocation = (token, keyword) => {
    return fetch(`${API}/v1/maps/name?keyword=${keyword}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        });
};

export const getGeocode = (token, coordinate) => {
    return fetch(`${API}/v1/maps/coordinate?latitude=${coordinate.latitude}&longitude=${coordinate.longitude}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        });
};